<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "AuthenticateViaToken" });
import { Modal } from "../../../../components/index.js";
import { Paragraph } from "../../../../typography/index.js";
import { QUERY_STATE } from "../../../../stores/query.js";
import { IS_AUTHENTICATED } from "../../../../stores/state.js";
import * as API from "../../services/api.js";
import { onMount } from "svelte";
import { navigate } from "svelte-navigator";
let error;
const authenticateViaToken = async (urlToken) => {
    const RESPONSE = await API.authenticateViaToken(urlToken);
    if ("error" in RESPONSE) {
        ({ error } = RESPONSE);
    }
    QUERY_STATE.removeParameter("token");
};
onMount(() => {
    const TOKEN = QUERY_STATE.getParameter("token");
    if ($IS_AUTHENTICATED) {
        QUERY_STATE.removeParameter("token");
        navigate(window.location.href.replace(window.location.hash, ""), { replace: true });
        return;
    }
    if (typeof TOKEN !== "string") {
        return;
    }
    void authenticateViaToken(TOKEN);
});
</script>

{#if error !== undefined}
    <Modal hash = '#one-time-link'>
        <Paragraph css = '!mb-0' color = 'error' label = { error }/>
    </Modal>
{/if}